import { Switch, withStyles } from '@material-ui/core';
import { Theme } from '@material-ui/core/styles';

const SWITCH_HEIGHT = 42;

export const WarboxSwitch = withStyles((theme: Theme) => ({
    root: {
        width: 125,
        height: SWITCH_HEIGHT,
        padding: 0,
    },
    switchBase: {
        padding: 4,
        '&$checked': {
            transform: 'translateX(82px)',
            color: '#fff',
            '& + $track': {
                backgroundColor: theme.palette.primary.main,
                opacity: 1,
            },
        },
    },
    thumb: {
        width: 34,
        height: 34,
        border: 'none',
    },
    track: {
        borderRadius: SWITCH_HEIGHT / 2,
        backgroundColor: '#dde5ec',
        opacity: 1,
        position: 'relative',
        '&:before, &:after': {
            position: 'absolute',
            top: '50%',
            transform: 'translateY(-50%)',
            fontSize: 12,
            fontWeight: 600,
            color: theme.palette.background.paper,
        },
        '&:before': {
            content: "'ON'",
            left: 14,
            opacity: 0,
        },
        '&:after': {
            content: "'OFF'",
            right: 14,
            color: '#9ca3af',
        },
    },
    checked: {
        '& + $track': {
            '&:before': {
                opacity: 1,
            },
            '&:after': {
                opacity: 0,
            },
        },
    },
}))(Switch);
